module.exports = __webpack_public_path__ + "img/tenant-lounge.5b01e4a1.svg";